import { Component } from '@angular/core';

/**
 * A shell component that displays the header
 */
@Component({
  selector: 'app-header-shell',
  template: `
            <app-header></app-header>
            <router-outlet></router-outlet>
            `
})
export class HeaderShellComponent {

  constructor() { }

}
